// A panel the person chose while a session was starting wins (e2e
// 2026-10-31, navigation 4): the entry's start-session can answer seconds
// after the bar shows, and its landing (interfaceTrigger 'start_session')
// set activePanel to 'session' over a tab tapped meanwhile, leaving the
// room on screen and ?panel=<tab> in the address. start_session marks when
// it asks; a choice recorded after the mark (a tab tapped, the address
// naming a panel) keeps the panel the page already shows.
export function panelChoices () {
  let seq = 0
  return {
    /** A tab tapped, or a ?panel= the address now names. */
    chose () { seq += 1 },
    /** Taken as a session start asks the server. */
    mark () { return seq },
    /** Chosen since this mark? */
    since (mark) { return mark != null && seq !== mark },
  }
}

/** Where a session start lands: on the session, unless the person chose a panel since it began. */
export function landingAfterSessionStart (choices, mark, current) {
  return choices.since(mark) ? current : 'session'
}
